import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export type RefuseReinclusionReason = "no_clinical_need" | "non_compliant" | "other";
export type SuggestedReinclusionReason =
  | "tir_below_threshold"
  | "tbr_above_threshold"
  | "tir_and_tbr_outside_bounds"
  | "patient_message";

export type ReinclusionAgentSuggestion = {
  id: string;
  tir?: number;
  tbr?: number;
  notTelemonitoredSince?: string;
  suggestedReason?: SuggestedReinclusionReason;
  suggestedAt?: string;
  autoResolveDate?: string;
  createdAt: string;
};

export const reinclusionAgentSuggestionSchema: Schema<ReinclusionAgentSuggestion> = cz.camelCaseObject({
  id: cz.id(),
  tir: cz.optional(z.number()),
  tbr: cz.optional(z.number()),
  not_telemonitored_since: cz.optional(z.iso.date()),
  suggested_reason: cz.optional(
    z.literal(["tir_below_threshold", "tbr_above_threshold", "tir_and_tbr_outside_bounds", "patient_message"]),
  ),
  suggested_at: cz.optional(cz.datetime()),
  auto_resolve_date: cz.optional(z.iso.date()),
  created_at: cz.datetime(),
});

export const refuseReinclusionReasonTranslationMapping = (data: RefuseReinclusionReason | undefined): string => {
  switch (data) {
    case "no_clinical_need":
      return "models.refuseReinclusionReason.noClinicalNeed";
    case "non_compliant":
      return "models.refuseReinclusionReason.nonCompliant";
    case "other":
      return "models.refuseReinclusionReason.other";
    default:
      return "models.refuseReinclusionReason.unknown";
  }
};

export const suggestedReinclusionReasonTranslationMapping = (data: SuggestedReinclusionReason | undefined): string => {
  switch (data) {
    case "patient_message":
      return "reinclusion.agent.banner.titlePatientMessage";
    default:
      return "reinclusion.agent.banner.title";
  }
};
